import { Select } from '@lunary/ui-web/select'
import type { AuditActorDto } from '@lunary/api-client'
import { ROLE_LABELS, SECTIONS, SECTION_LABELS } from './labels'
import type { Kind } from './labels'

export type AuditFilter = {
  readonly kind: Kind | ''
  readonly actorId: string
  readonly section: string
  readonly days: number
  readonly q: string
}

export const EMPTY_FILTER: AuditFilter = { kind: '', actorId: '', section: '', days: 7, q: '' }

const PERIODS = [1, 7, 30, 90, 0] as const
const PERIOD_LABELS: Readonly<Record<number, string>> = {
  1: 'Сегодня',
  7: '7 дней',
  30: '30 дней',
  90: '90 дней',
  0: 'Всё время',
}

type Props = {
  readonly value: AuditFilter
  readonly actors: readonly AuditActorDto[]
  readonly onChange: (next: AuditFilter) => void
}

export function AuditFilters({ value, actors, onChange }: Props) {
  const set = (patch: Partial<AuditFilter>) => onChange({ ...value, ...patch })
  const kinds: ReadonlyArray<{ v: Kind | ''; label: string }> = [
    { v: '', label: 'Все' },
    { v: 'change', label: 'Изменения' },
    { v: 'error', label: 'Ошибки' },
  ]
  return (
    <div className="row" style={{ marginBottom: 16 }}>
      <div className="filter-bar" role="group" aria-label="Тип записей" style={{ marginBottom: 0 }}>
        {kinds.map((k) => (
          <button
            key={k.v}
            type="button"
            className={value.kind === k.v ? 'active' : undefined}
            aria-pressed={value.kind === k.v}
            onClick={() => set({ kind: k.v })}
          >
            {k.label}
          </button>
        ))}
      </div>
      <Select
        size="sm"
        sheet="never"
        aria-label="Кто"
        value={value.actorId}
        options={[
          { value: '', label: 'Все сотрудники' },
          ...actors.map((a) => ({ value: a.id, label: a.name ?? ROLE_LABELS[a.role] ?? a.id })),
        ]}
        onChange={(v) => set({ actorId: v })}
      />
      <Select
        size="sm"
        sheet="never"
        aria-label="Раздел"
        value={value.section}
        options={[{ value: '', label: 'Все разделы' }, ...SECTIONS.map((s) => ({ value: s, label: SECTION_LABELS[s] ?? s }))]}
        onChange={(v) => set({ section: v })}
      />
      <Select
        size="sm"
        sheet="never"
        aria-label="Период"
        value={String(value.days)}
        options={PERIODS.map((d) => ({ value: String(d), label: PERIOD_LABELS[d] ?? String(d) }))}
        onChange={(v) => set({ days: PERIODS.find((d) => String(d) === v) ?? 7 })}
      />
      <input
        type="search"
        aria-label="Поиск по журналу"
        placeholder="id объекта, request id, код ошибки"
        value={value.q}
        onChange={(e) => set({ q: e.target.value })}
      />
    </div>
  )
}
